import { type UseQueryResult, useQuery } from 'react-query';
import { TransferAgentService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetActiveTransferList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const activeTransferList = useQuery(
    ['getActiveTransferList'],
    async () => {
      return await handleRequest(
        TransferAgentService.getApiAwardApiAppTransferAgentActiveTransferList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return activeTransferList;
};

export default useGetActiveTransferList;
